import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import CssBaseline from "@mui/material/CssBaseline";
import { useNavigate } from "react-router";

import { DevBar, SnackbarProvider } from "@dfp/react-components";
import { MsalAccountProvider } from "@dfp/react-msal-support";
import { CustomNavigationClient } from "@dfp/react-msal-support";

import { AppRoutes } from "./AppRoutes";
import { API_ENDPOINT_PREFIX, COMMIT_ID, DEV_BAR_COLOR } from "./config";

type Props = {
  pca: PublicClientApplication;
};

function App({ pca }: Props) {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <MsalAccountProvider>
        <DevBar
          color={DEV_BAR_COLOR}
          commitId={COMMIT_ID}
          apiEndpointPrefix={API_ENDPOINT_PREFIX}
        />
        <SnackbarProvider>
          <CssBaseline />
          <AppRoutes />
        </SnackbarProvider>
      </MsalAccountProvider>
    </MsalProvider>
  );
}

export default App;
